function fit(el)
{
    el.style.height = 'auto';
    el.style.height = (el.scrollHeight || 0) + 'px';
}
function updateCount(wrap, el, max)
{
    const c = wrap.querySelector('.textarea__count');
    if (!c) return;
    const v = el.value.length;
    c.textContent = max ? `${v}/${max}` : `${v}`;
    if (max) wrap.classList.toggle('textarea--error', v > max);
}
document.querySelectorAll('.textarea').forEach(wrap =>
{
    const ta = wrap.querySelector('textarea'); if (!ta) return;
    const max = parseInt(ta.getAttribute('maxlength') || '0', 10) || 0;
    const on = () => { fit(ta); updateCount(wrap, ta, max); };
    ['input','change'].forEach(evt => ta.addEventListener(evt, on));
    on();
});
